<div class="card">
    <div class="card-header">
        <button class="btn btn-light btn-xs" (click)="expanded = !expanded">
            @if (expanded) {
                <span class="dripicons-chevron-up"></span>
            }
            @if (!expanded) {
                <span class="dripicons-chevron-down"></span>
            }
        </button>
        Images

        @if (inventoryId !== 0) {
            <button type="button" class="btn btn-sm btn-primary float-right" data-toggle="modal" data-target="#uploadImagesModal">Upload Image(s)</button>
        }
    </div>
    @if (expanded) {
    <div>
        <div class="card-body">
            <div cdkDropList class="image-list" (cdkDropListDropped)="drop($event)">
                <table class="table text-left table-borderless">
                    <thead>
                        <th>Order</th>
                        <th></th>
                        <th>Caption</th>
                        <th>Description</th>
                        <th></th>
                    </thead>
                    <tbody>
                        @for (image of images; track image) {
                        <tr cdkDrag [ngClass]="{'ribbon-box border border-primary': image.sortOrder == 1}">
                            <td class="text-center">{{image.sortOrder}}</td>
                            <td>
                                @if (image.sortOrder == 1) {
                                <div class="ribbon-two ribbon-two-primary">
                                    <span>{{ words[language][ 'primary' ] }}</span>
                                </div>
                                }
                                <img class="img-thumbnail" height="100" width="100" src="{{image.url}}" alt="{{image.caption}}">
                            </td>
                            <td>
                                <h5 class="card-title">{{image.caption}}</h5>
                            </td>
                            <td>
                                <p class="card-text">{{image.description}}</p>
                            </td>
                            <td>
                                <button class="btn btn-sm btn-outline-info" data-target="#previewEditImage" data-toggle="modal" (click)="setId(image.id)"><span class="dripicons-pencil"></span></button>
                                <button class="btn btn-sm btn-outline-danger" data-target="#deleteImagesModal" data-toggle="modal" (click)="setId(image.id)"><span class="uil-trash-alt"></span></button>
                            </td>
                        </tr>
                        }
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    }
</div>


<!-- modals -->
<!-- preview and edit modal -->
<div class="modal fade" id="previewEditImage" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-xl modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">Preview & Edit Image</h4>
                <button type="button" class="btn btn-close" data-dismiss="modal">x</button>
            </div>
            <div class="modal-body">
                <div id="carouselExampleIndicators" class="carousel slide" data-interval="false">
                    <div class="row">
                        <div class="col-md-1">
                            <a class="carousel-control-prev text-dark bg-dark" href="#carouselExampleIndicators" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon"></span>
                            </a>
                        </div>
                        <div class="col-md-10">
                            <div class="carousel-inner" data-ride="false" role="listbox">
                                <form [formGroup]="information">
                                    <div formArrayName="imageList">
                                        @for (singleImage of imageList.controls; track singleImage; let i = $index) {
                                        <div class="carousel-item" [ngClass]="{'active': selectedId == singleImage.get('id').value}">
                                            <div [formGroup]="singleImage">
                                                <div class="row">
                                                    <div class="col-md-6 col-sm-12">
                                                        <img class="d-block img-fluid" [src]="singleImage.get('url').value">
                                                    </div>
                                                    <div class="col-md-6 col-sm-12">
                                                        <div class="form-group col-md-12 col-sm-12">
                                                            <small class="text-dark">{{words[language][ 'Caption' ]
                                                                }}</small>
                                                            <input class="form-control form-control-sm text-dark" type="text" formControlName="caption">
                                                        </div>
                                                        <div class="form-group col-md-12 col-sm-12">
                                                            <small class="text-dark">{{words[language][
                                                                'Description' ] }}</small>
                                                            <textarea class="form-control form-control-sm" cols="30" formControlName="description" rows="4"></textarea>
                                                        </div>
                                                        <div class="form-group col-md-12 col-sm-12">
                                                            <div class="form-check">
                                                                <input type="checkbox" class="form-check-input" formControlName="markForDeletion">
                                                                <label class="form-check-label" for="markForDeletion">Mark for Deletion</label>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>
                                </form>
                            </div>
                        </div>
                        <div class="col-md-1">
                            <a class="carousel-control-next text-dark bg-dark" href="#carouselExampleIndicators" role="button" data-slide="next">
                                <span class="carousel-control-next-icon"></span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light btn-close" id="btn-close-modal-modify-image" data-dismiss="modal" (click)="resetInformation()">Close</button>
                <button type="button" class="btn btn-primary" (click)="modifyImage()">Save All</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- upload modal -->
<div class="modal fade" id="uploadImagesModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title" id="mySmallModalLabel">Upload Image(s)</h4>
                <button type="button" class="btn btn-close" data-dismiss="modal">x</button>
            </div>
            <div class="modal-body">
                <div class="col-md-12">
                    <div class="row">
                        <div class="col-md-4">
                            <div class="file-upload w-100">
                                <div class="image-upload-wrap p-3 py-5">
                                    <input class="file-upload-input" id="file-upload-input" type='file' [accept]="extensions" (change)="uploadImages($event)" multiple />
                                    <div class="drag-text">
                                        <span class="h1 text-muted dripicons-cloud-upload"></span>
                                        <h3 class="text-muted">{{words[language][ 'uploadImages' ] }}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-8">
                            <div class="row d-flex justify-content-between">
                                <h5>Uploaded Images</h5>
                                <h5>{{imagesToUpload.length}} / {{allFiles.length}} images uploaded</h5>
                            </div>
                            <table class="table">
                                <thead>
                                    <tr>
                                        <th>Name</th>
                                        <th>Type</th>
                                        <th></th>
                                    </tr>
                                </thead>
                                @for (image of imagesToUpload; track image; let i = $index) {
                                <tr>
                                    <td>{{image.name}}</td>
                                    <td>{{image.fileType}}</td>
                                    <td class="text-right"><button class="btn btn-sm btn-outline-danger" (click)="deleteImageToUpload(i)"><span class="uil-trash-alt"></span></button></td>
                                </tr>
                                }
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-light btn-close btn-sm" id="btn-close-modal-upload-image" data-dismiss="modal">Close</button>
                @if (showUploadButton && !loading) {
                    <button class="btn btn-sm btn-outline-info" (click)="createImages(imagesToUpload)">
                        Upload Images
                    </button>
                }
                @if (loading) {
                    <button class="btn btn-sm btn-outline-info">Saving Images...
                        <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    </button>
                }
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->

<!-- delete modal -->
<div class="modal fade" id="deleteImagesModal" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="mySmallModalLabel">
    <div class="modal-dialog modal-sm modal-dialog-centered">
        <div class="modal-content">
            <div class="modal-body d-flex flex-wrap align-items-center justify-content-center">
                <span class="uil-trash-alt text-danger display-1"></span>
                <h4 class="text-danger w-100 text-center">{{words[language][ 'delete' ] }}</h4>
                <span class="text-dark my-3 text-center">Are you sure you want to delete this image?</span>
                <button class="btn btn-danger mt-2" (click)="deleteImage()" [disabled]="loading">
                    @if (loading) {
                    <span class="spinner-grow spinner-grow-sm mr-1" role="status"></span>
                    }
                    {{words[language][ 'yes' ] }}</button>
                <button class="btn btn-secondary mt-2 ml-2" data-dismiss="modal" id="btn-close-modal-delete-image">No</button>
            </div>
        </div><!-- /.modal-content -->
    </div><!-- /.modal-dialog -->
</div><!-- /.modal -->